/**
 * It enables Google Tag Manager to fire tags
 */
export default class GTMService {
  constructor() {
    this.isInitialized = true;

    this.cityTvPageToRun = GTMService.checkCityTvPageToRun();
    if (!window.dataLayer) {
      this.isInitialized = false;
      return;
    }

    this.init();
  }

  init() {
    window.mcfcGtmService = this; // expose service to global scope
    this.gtmDataLayer = { // initial data layer
      event: 'interaction',
      eventCategory: null,
      eventAction: null,
      eventLabel: null,
    };

    if (this.cityTvPageToRun) {
      this.cityTvPageAutoRun();
    }
  }

  /**
   * Fill in data layer and fire tag
   * @param {string} action
   * @param {string} category
   * @param {string} label
   * @param {string} name // optional
   */
  setGtmDataLayer(eventAction, eventCategory, eventLabel, name) {
    const gtmDataLayer = {
      eventCategory,
      eventAction,
      eventLabel,
    };
    this.fireGtmEvent(gtmDataLayer, name);
  }

  /**
   * Fire event tag by pushing to data layer queue
   * @param {object} myDataLayer
   * @param {string} name
   */
  fireGtmEvent(myDataLayer, name) {
    let { gtmDataLayer } = this;
    if (name) {
      gtmDataLayer = Object.assign(this.gtmDataLayer, { event: name });
    }
    if (GTMService.isValiDataLayer(myDataLayer)) {
      Object.assign(gtmDataLayer, myDataLayer);
      window.dataLayer.push(gtmDataLayer);
    }
  }

  /**
   * Validates data layer to not be empty
   * @param {object} myDataLayer
   */
  static isValiDataLayer(myDataLayer) {
    if (myDataLayer
      && myDataLayer.eventCategory
      && myDataLayer.eventAction
      && myDataLayer.eventLabel) {
      return true;
    }
    return false;
  }

  /**
   * checks pages only with query result=success
   */
  static checkCityTvPageToRun() {
    return window.location.search.substring(1)
      .split('&')
      .filter((s) => s.split('=')[0] === 'result' && s.split('=')[1] === 'success').length;
  }

  /**
   * Fires pre-defined tag
   */
  cityTvPageAutoRun() {
    this.setGtmDataLayer('Result Success', 'Subscriptions', 'City Plus');
  }
}
